<template>
    <div v-if="!list.loading">
        <milestones-list-item
            v-for="milestone in list.data.results"
            :milestone="milestone"
            :key="milestone.id"
            :space="space"/>

        <base-paginator
            :current="parseInt($route.query.page || 1)"
            :total-count="list.data.count || 0"
            :per-page="15"/>
    </div>

    <div v-else class="loader"></div>
</template>

<script>
import { mapState } from 'vuex';
import MilestonesListItem from './MilestonesListItem.vue';

export default {
    components: { MilestonesListItem },
    props: ['space'],
    computed: mapState('milestones', ['list', 'update']),
    created() {
        this.load();
    },
    watch: { $route: 'load' },
    methods: {
        load() {
            this.$store.dispatch('milestones/list', {
                page: this.$route.query.page || 1,
                space_id: this.space.id,
            });
        },
    },
};
</script>

<style scoped>
.milestone {
    padding: 0 0.7rem 0 1rem;
}
</style>
